import { render, staticRenderFns } from "./CreateWork.vue?vue&type=template&id=8bf44c8a&scoped=true"
import script from "./CreateWork.vue?vue&type=script&lang=js"
export * from "./CreateWork.vue?vue&type=script&lang=js"
import style0 from "./CreateWork.vue?vue&type=style&index=0&id=8bf44c8a&prod&scoped=true&lang=less"
import style1 from "./CreateWork.vue?vue&type=style&index=1&id=8bf44c8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf44c8a",
  null
  
)

export default component.exports